"use client";

import { isIdentityVerificationRoute } from "@faire/deprecated-retailer-visitor-shared/components/App/AppModals/isIDV";
import { isMobileApp } from "@faire/deprecated-retailer-visitor-shared/lib/isMobileApp";
import { useIsSemDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { usePromoBanners } from "@faire/deprecated-retailer-visitor-shared/stores/ui/usePromoBanners";
import { Expressive } from "@faire/slate/foundation/color";
import { LoadingSpinner } from "@faire/web/slate-deprecated/LoadingSpinner/LoadingSpinner";
import { Row } from "@faire/web/slate/Layout";
import React, { lazy, Suspense } from "react";

export const LazyPromoBanner: React.FC = () => {
  const { isVisible: isPromoBannerVisible } = usePromoBanners();
  const isSemDiscoverPage = useIsSemDiscoverPage();

  if (
    isSemDiscoverPage ||
    !isPromoBannerVisible ||
    (isMobileApp() && isIdentityVerificationRoute())
  ) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <Row
          justify="center"
          align="center"
          style={{
            height: "36px",
            backgroundColor: Expressive.surface.neutral,
          }}
        >
          <LoadingSpinner data-test-id="faire-promo-spinner" size="small" />
        </Row>
      }
    >
      <LazyPromoBannerBase />
    </Suspense>
  );
};

const LazyPromoBannerBase = lazy(() =>
  import(
    /* webpackChunkName: "retailer-promo-banner" */ "@faire/deprecated-retailer-visitor-shared/components/Notifications/PromoBanner/PromoBanner"
  ).then((m) => ({ default: m.PromoBanner }))
);
